import { render, staticRenderFns } from "./AdminAccountTabData.vue?vue&type=template&id=0850dde2&scoped=true&"
import script from "./AdminAccountTabData.vue?vue&type=script&lang=js&"
export * from "./AdminAccountTabData.vue?vue&type=script&lang=js&"
import style0 from "./AdminAccountTabData.vue?vue&type=style&index=0&id=0850dde2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0850dde2",
  null
  
)

export default component.exports